import { baseFetch } from '../../baseFetch';
import { UpdateShowDeltaTResponseSchema } from './orders.schema';

export const updateOrderShowDeltaT = (
  orderId: number,
  deltaTVisible: boolean,
) => {
  return baseFetch(
    'internal-v2',
    `/solar_orders/${orderId}/show_delta_t`,
    UpdateShowDeltaTResponseSchema.defined(),
    {
      method: 'PATCH',
      requestBody: {
        show_delta_t: deltaTVisible,
      },
    },
  );
};
